import { Sizes } from "../ErrorPage.types";
export function getXmarkSize(size) {
    switch (size) {
        case Sizes.SM:
            return 7;
        case Sizes.MD:
            return 10;
        case Sizes.LG:
            return 10;
        default:
            return 7;
    }
}
export function getErrorXmarkSize(size) {
    switch (size) {
        case Sizes.SM:
            return "256px";
        case Sizes.MD:
            return "320px";
        case Sizes.LG:
            return "320px";
        default:
            return "320px";
    }
}
export function getErrorIcon(size) {
    switch (size) {
        case Sizes.SM:
            return { w: "240px" };
        case Sizes.MD:
            return { w: "320px" };
        case Sizes.LG:
            return { w: "320px" };
        default:
            return { w: "240px" };
    }
}
//# sourceMappingURL=index.js.map